import { ANTHROPIC_MODEL_EFFORTS } from "../anthropic/manifest";
import { defineAIProviderManifest } from "../manifest";

export const manifest = defineAIProviderManifest({
  id: "bedrock-anthropic",
  label: "Amazon Bedrock (Anthropic)",
  description:
    "Route through Amazon Bedrock using your server's AWS credentials.",
  defaultChatModel: "claude-opus-4-8",
  defaultFastModel: "claude-haiku-4-5-20251001",
  defaultChatEffort: "low",
  modelEfforts: ANTHROPIC_MODEL_EFFORTS,
  configurable: false,
  requiresChatModel: false,
  reasoningSignatureProviderOptionsKey: "bedrock",
  credentialFields: [],
  packCredentials: () => ({ baseUrl: "", apiKey: "" }),
  unpackCredentials: () => ({}),
  subtitleField: null,
  attachmentSupport: {
    documentMediaTypes: [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    extensionToMediaType: {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  },
});
